import React from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';

function Accueil() {
  const isMobile = window.innerHeight > window.innerWidth;
  const carteMedia = { height: '15rem' };
  const carte = { opacity: '0.8' };

  return (
    <Container maxWidth={false} className={isMobile ? 'conteneur-accueil-mobile' : 'conteneur-accueil'}>
      <Grid container spacing={5}>
        <Grid item xs={12} md={3}><Typography color="secondary" variant="h3">Gestion des equipements SyncStats</Typography></Grid>
        <Grid item xs={12} md={9} />
      </Grid>
      <Grid container spacing={5}>
        <Grid item xs={12} md={3}>
          <a href="./Administration">
            <Card style={carte}>
              <CardActionArea>
                <CardMedia style={carteMedia} height='10px' />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">Administration</Typography>
                  <Typography variant="body2" color="textSecondary" component="p">Ce sera votre "Intranet"</Typography>
                </CardContent>
              </CardActionArea>
              <CardActions><Button size="small" color="primary">Laissez une note</Button></CardActions>
            </Card>
          </a>
        </Grid>
        <Grid item xs={12} md={3}>
          <a href="./Ingenierie">
            <Card style={carte}>
              <CardActionArea>
                <CardMedia style={carteMedia} height='10px' />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">Ingenierie</Typography>
                  <Typography variant="body2" color="textSecondary" component="p">Ce sera votre "Intranet"</Typography>
                </CardContent>
              </CardActionArea>
              <CardActions><Button size="small" color="primary">Laissez une note</Button></CardActions>
            </Card>
          </a>
        </Grid>
        <Grid item xs={12} md={3}>
          <a href="./Marketing">
            <Card style={carte}>
              <CardActionArea>
                <CardMedia style={carteMedia} height='10px' />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">Vente et Marketing</Typography>
                  <Typography variant="body2" color="textSecondary" component="p">Ce sera votre "Intranet"</Typography>
                </CardContent>
              </CardActionArea>
              <CardActions><Button size="small" color="primary">Laissez une note</Button></CardActions>
            </Card>
          </a>
        </Grid>
        <Grid item xs={12} md={3}>
          <a href="./Operations">
            <Card style={carte}>
              <CardActionArea>
                <CardMedia style={carteMedia} height='10px' />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">Operations</Typography>
                  <Typography variant="body2" color="textSecondary" component="p">Ce sera votre "Intranet"</Typography>
                </CardContent>
              </CardActionArea>
              <CardActions><Button size="small" color="primary">Laissez une note</Button></CardActions>
            </Card>
          </a>
        </Grid>
      </Grid>
      <Grid container spacing={5}><Grid item xs={12}><Paper className="paperFull">Nous avons hate que ca marche su'a coche!</Paper></Grid></Grid>
    </Container>
  );
}

export default Accueil;



// WEBPACK FOOTER //
// src/components/Accueil.js